(function () {
    'use strict';

    angular
        .module('secretSantaFirebase', [
            'ngMaterial',
            'ngAnimate',
            'ngCookies',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ui.router',
            'mdl',
            'firebase',
            'secretSantaFirebase.login'
        ]);

})();

/**
 * Created by guga on 12/27/16.
 */
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .controller('CopyDialogController', CopyDialogController);

  /** @ngInject */
  function CopyDialogController(Link, toast, $mdDialog) {
    var vm = this;
    vm.link = Link;
    vm.close = close;
    vm.copy = copy;

    function close() {
      $mdDialog.hide();
    }
    function copy(ev) {
      var temp = document.getElementById('idCopyText');
      temp.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        toast.success('URL is copied in the clipboard');
        $mdDialog.hide();
      } catch (err) {
        toast.error('Error copying, copy by yourself');
      }
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('secretSantaFirebase')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      // {
      //   'title': 'AngularJS',
      //   'url': 'https://angularjs.org/',
      //   'description': 'HTML enhanced for web apps!',
      //   'logo': 'angular.png'
      // },
      // {
      //   'title': 'BrowserSync',
      //   'url': 'http://browsersync.io/',
      //   'description': 'Time-saving synchronised browser testing.',
      //   'logo': 'browsersync.png'
      // },
      // {
      //   'title': 'GulpJS',
      //   'url': 'http://gulpjs.com/',
      //   'description': 'The streaming build system.',
      //   'logo': 'gulp.png'
      // },
      // {
      //   'title': 'Jasmine',
      //   'url': 'http://jasmine.github.io/',
      //   'description': 'Behavior-Driven JavaScript.',
      //   'logo': 'jasmine.png'
      // },
      // {
      //   'title': 'Karma',
      //   'url': 'http://karma-runner.github.io/',
      //   'description': 'Spectacular Test Runner for JavaScript.',
      //   'logo': 'karma.png'
      // },
      // {
      //   'title': 'Protractor',
      //   'url': 'https://github.com/angular/protractor',
      //   'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
      //   'logo': 'protractor.png'
      // },
      // {
      //   'title': 'Material Design Lite',
      //   'url': 'http://www.getmdl.io/',
      //   'description': 'Add a Material Design look and feel to your websites.',
      //   'logo': 'material-design-lite.png'
      // },
      // {
      //   'title': 'Sass (Node)',
      //   'url': 'https://github.com/sass/node-sass',
      //   'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
      //   'logo': 'node-sass.png'
      // }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

/**
 * Created by guga on 12/27/16.
 */
(function () {
  'use strict';
  angular
    .module('secretSantaFirebase')
    .factory('toast', Toast);

  /** @ngInject */
  function Toast($mdToast) {
    return {
      success: function (message){
        $mdToast.show($mdToast.simple({ position: 'bottom right', hideDelay: 2200}).content(message));
      },
      error: function (message){
        $mdToast.show($mdToast.simple({ position: 'bottom right', hideDelay: 2200}).content(message));
      }
    };
  }
})();
/**
 * Created by zura on 12/12/16.
 */
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .factory('UserService', UserService);

  /** @ngInject */
  function UserService(Auth, $rootScope, $log) {
    var users = {
      current: null,

      saveUserData: saveUserData
    };

    function createCurrentUser(firebaseUser) {
      saveUserData('users/' + firebaseUser.uid, firebaseUser)
    }

    Auth.$onAuthStateChanged(function (firebaseUser) {
      users.current = firebaseUser;
      if (firebaseUser != null) {
        firebase.database().ref('users/' + firebaseUser.uid).once('value', function (snapshot) {
          if (!snapshot.exists()) {
            createCurrentUser(firebaseUser);
          }
        }, function (error) {
          createCurrentUser(firebaseUser);
        });
      }
      $rootScope.$emit('userStateChange', firebaseUser);
      $log.debug("User state has been changed. Current User: ", firebaseUser);
    });

    return users;
  }

  function saveUserData(ref, firebaseUser) {
    firebase.database().ref(ref).set({
      displayName: firebaseUser.displayName ? firebaseUser.displayName : '',
      email: firebaseUser.email ? firebaseUser.email : '',
      photoURL: firebaseUser.photoURL ? firebaseUser.photoURL : '',
    }).then(function(){
      console.log(this);
    });
  }
})();
/**
 * Created by zura on 12/12/16.
 */
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .factory('FirebaseService', FirebaseServiceFn);

  /** @ngInject */
  function FirebaseServiceFn($firebaseRef, $firebaseArray, $firebaseObject) {
    var rootRef = $firebaseRef;

    var FirebaseService = {
      rootRef: rootRef,
      getGroupsByUser: getGroupsByUser,
      getUsersByGroup: getUsersByGroup,
      getGroupById: getGroupById,
    };

    return FirebaseService;

    function getGroupsByUser(userId) {
      return $firebaseArray(firebase.database().ref('userGroups/' + userId));
    }

    function getUsersByGroup(groupId) {
      return $firebaseArray(firebase.database().ref('groupUsers/' + groupId));
    }

    function getGroupById(groupId) {
      return $firebaseObject(firebase.database().ref('groups/' + groupId)).$loaded();
    }

  }
})();
/**
 * Created by zura on 12/12/16.
 */
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .factory('Auth', Auth);

  /** @ngInject */
  function Auth($firebaseAuth) {
    var auth = $firebaseAuth();
    auth.loginState = 'auth.login';
    auth.mainState = 'app.main';

    return auth;
  }
})();
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($rootScope, UserService, FirebaseService, $state, Auth, $mdDialog,toast,$timeout, $scope) {
    var vm = this;

    vm.isLogedIn = true;
    vm.isOwner = true;
    vm.user = null;
    vm.groupName = null;
    vm.groups = null;

    // methods
    vm.createGroup = createGroup;
    vm.openGroup = openGroup;
    vm.removeGroup = removeGroup;
    vm.logOut = logOut;
    vm.copyGroupLink = copyGroupLink;
    vm.copy = copy;


    init();

    function init() {
        $timeout(function () {
          if(UserService.current !== null){
            vm.user = UserService.current;
            vm.groups = FirebaseService.getGroupsByUser(vm.user.uid);
          }else{
            init();
          }
        },100);
    }

    function createGroup() {
      var dataGroups = {
        'name': vm.groupName,
        'creatorId': vm.user.uid
      };


      var groupRef = firebase.database().ref('groups').push();
      var groupId = groupRef.getKey();

      var updateData = {};
      updateData['groups/' + groupId] = dataGroups;
      updateData['userGroups/' + vm.user.uid + '/' + groupId] = dataGroups;
      firebase.database().ref().update(updateData);


      UserService.saveUserData('groupUsers/' + '/' + groupId + '/' + vm.user.uid, vm.user);

      vm.groupName = null;
      vm.recentUrl = getGroupLink(groupId);
      // firebase.database().ref('groupUsers').push().set(data);
      $timeout(function () {
        angular.element('#idGroupContainer').blur();
        $scope.createGroupForm.$setPristine();
        $scope.createGroupForm.$setUntouched();
      });

    }

    function logOut() {
      Auth.$signOut();
    }

    function openGroup(group) {
      $state.go('app.group', {'groupId': group.$id});
    }

    function removeGroup(group) {
      var confirm = $mdDialog.confirm()
        .title('Attention')
        .textContent('Would you like to delete Group '+ group.name +'?')
        .ok('Yes')
        .cancel('No');
      $mdDialog.show(confirm).then(function() {
        var groupId = group.$id;
        FirebaseService.getUsersByGroup(groupId).$loaded().then(function (res) {
          var updateData = {};
          for (var i = 0; i < res.length; i++) {
            updateData['userGroups/' + res[i].$id + '/' + groupId] = null;
          }
          updateData['groupUsers/' + groupId] = null;
          updateData['groups/' + groupId] = null;

          firebase.database().ref().update(updateData);

        });

      }, function() {
        //cancel
      });
    }

    function copyGroupLink(group) {
      $mdDialog.show({
          clickOutsideToClose: true,
          templateUrl: 'app/main/dialogs/copy-dialog/copy-dialog.html',
          controller: 'CopyDialogController',
          controllerAs: 'vm',
          locals: {
            Link: getGroupLink(group.$id)
          }
        }
      );
    }

    function copy(ev) {
      var temp = document.getElementById('idCopyTextMain');
      temp.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        toast.success('URL is copied in the clipboard');
        $mdDialog.hide();
      } catch (err) {
        toast.error('Error copying, copy by yourself');
      }
    }

    function getGroupLink(id) {
      var url = window.location.href;
      var arr = url.split("/");
      return arr[0] + "//" + arr[2] + '/#/join-game/' + id;
    }
  }
})();

/**
 * Created by guga on 12/12/16.
 */
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase.login', [])
    .config(Config);

  /** @ngInject */
  function Config($stateProvider) {

    $stateProvider
      .state('auth',{
        abstract: true,
        views: {
          'main@': {
            templateUrl: 'app/layouts/content.html'
          }
        }
      })
      .state('auth.login', {
        url: '/login/:groupId?',
        bodyClass: 'login',
        views: {
          'content@auth': {
            templateUrl: 'app/login/login.html',
            controller : 'LoginController as vm'
          }
        }
      });

  }
})();
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase.login')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(Auth, $log, $stateParams, $state) {
    var vm = this;
    vm.loginWithGoogle = loginWithGoogle;
    vm.loginWithFacebook = loginWithFacebook;


    function loginWithGoogle() {
      var provider = new firebase.auth.GoogleAuthProvider();

      Auth
        .$signInWithPopup(provider)
        .then(function successCallback() {
          $log.debug("Sign in with popup callback", arguments);
        })
        .catch(function errorCallback(error) {
          vm.errorMessage = error.message;
        });
    }

    function loginWithFacebook() {
      var provider = new firebase.auth.FacebookAuthProvider();

      Auth
        .$signInWithPopup(provider)
        .then(function successCallback() {
          $log.debug("Sign in with popup callback", arguments);
        })
        .catch(function errorCallback(error) {
          vm.errorMessage = error.message;
        });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .controller('JoinGameController', JoinGameController);

  /** @ngInject */
  function JoinGameController($rootScope,  UserService, FirebaseService, $state, Auth, group) {
    var vm = this;
    vm.group = group;
    vm.user = UserService.current;
    
    init();
    
    function init() {
      //console.log(vm.user);
      // $rootScope.$on('userStateChange',function (user) {
      //   vm.user = user;
      // });
      if(vm.group){
        if(vm.user){
          joinGroup();
        }
      }
    }
    
    function joinGroup() {
        firebase.database().ref('userGroups/' + vm.user.uid + '/' + vm.group.$id).once('value', function (res) {
          if(!res.val()){
            var updateData = {};
            var userTemp = {
              displayName: vm.user.displayName,
              email: vm.user.email,
              photoURL: vm.user.photoURL
            };
            var groupTemp = {
              creatorId: vm.group.creatorId,
              name: vm.group.name
            };
            updateData['userGroups/' + vm.user.uid + '/' + vm.group.$id] = groupTemp;
            updateData['groupUsers/' + vm.group.$id +'/'+ vm.user.uid] = userTemp;
            firebase.database().ref().update(updateData);
          }
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .controller('GroupController', GroupController);

  /** @ngInject */
  function GroupController($rootScope, toast, UserService, FirebaseService, users, $stateParams, Auth, $firebaseObject) {

    var vm = this;
    vm.users = users;
    vm.user = UserService.current;
    vm.generated = true;
    $rootScope.backState = 'app.main';
    //methods
    vm.removeUser = removeUser;
    vm.generateAssignments = generateAssignments;


    init();

    function init() {
      firebase.database().ref('assigned/' + $stateParams.groupId).once('value',function (res) {
        vm.generated = res.val() != null;
      });
      FirebaseService.getGroupById($stateParams.groupId).then(function (res) {
        vm.group = res;
      });
    }

    function removeUser(user) {
      var updateData = {};

      updateData['userGroups/'+user.$id+'/'+$stateParams.groupId] = null;
      updateData['groupUsers/'+$stateParams.groupId+'/'+user.$id] = null;

      firebase.database().ref().update(updateData);
    }

    function generateAssignments() {
      FirebaseService.getUsersByGroup($stateParams.groupId).$loaded().then(function (res) {
        var usersToAssign = [];
        var usersToChoose = [];

        for(var i = 0; i < res.length; i++){
          usersToAssign.push(res[i].$id);
          usersToChoose.push(res[i].$id);
        }

        generateData(usersToAssign,usersToChoose);

      });
    }

    function generateData(usersToAssign, usersToChoose) {

      if(usersToAssign.length < 2){
        toast.error('მომხმარებელთა რაოდენობა არასაკმარისია');
        return;
      }
      var updateData = null;
      var reset = 0;
      while(updateData == null && reset < 5){
        updateData = randomize(angular.copy(usersToAssign),angular.copy(usersToChoose));
        reset++;
      }
      if(reset == 5){
        toast.error('დაგენერირება ვერ მოხერხდა');
        return;
      }
      firebase.database().ref('assigned/' + $stateParams.groupId).update(updateData);
      toast.success('წარმატებით დაგენერირდა');
      vm.generated = true;
    }

    function randomize(assign, choose) {
      var updateData = {};
      for(var i = 0; i < assign.length; i++){
        var choosedUser = null;
        var reset = 0;
        while(choosedUser == null && choose.length > 0 && reset < 5){
          var index = Math.floor(Math.random() * (choose.length - 1 + 1)) + 0;
          var chosen = choose[index];
          if(chosen == assign[i]){
            reset++;
          }else{
            choosedUser = chosen;
            choose.splice(index,1);
          }
        }
        if(reset == 5){
          return null;
        }else{
          updateData[assign[i]] = choosedUser;
        }
      }
      return updateData;
    }
      // firebase.database().ref('groupUsers').push().set(data);
  }
})();

(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, Auth) {
    $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {
      // We can catch the error thrown when the $requireSignIn promise is rejected
      // and redirect the user back to the home page
      console.log(error, toState, toParams);
      if (error === "AUTH_REQUIRED") {
        var params = {};
        if (toState.name === 'join-game') {
          params = toParams;
        }
        $state.go(Auth.loginState, params);
      }
    });
    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {


    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: 'app/layouts/main.html'
          }
        }
      })
      .state('app.main', {
        url: '/',
        views: {
          'content@app': {
            templateUrl: 'app/main/main.html',
            controller: 'MainController as vm'
          }
        },
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          "currentAuth": ["Auth", function (Auth) {
            console.log("resolve");
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('app.group', {
        url: '/group/:groupId',
        views: {
          'content@app': {
            templateUrl: 'app/group/group.html',
            controller: 'GroupController as vm'
          }
        },
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          "currentAuth": ["Auth", function (Auth) {
            console.log("currentAuth resolve");
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$requireSignIn();
          }],
          "users": ["FirebaseService", "$stateParams", function (FirebaseService, $stateParams) {
            console.log("users resolve");
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return FirebaseService.getUsersByGroup($stateParams.groupId);
          }]
        }
      })
      .state('app.join-game', {
        url: '/join-game/:groupId',
        views: {
          'content@app': {
            templateUrl: 'app/main/joinGame.html',
            controller: 'JoinGameController as vm'
          }
        },
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          "currentAuth": ["Auth", function (Auth) {
            console.log("resolve");
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$requireSignIn();
          }],
          "group": ["FirebaseService", "$stateParams", function (FirebaseService, $stateParams) {
            console.log("users resolve");
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return FirebaseService.getGroupById($stateParams.groupId);
          }]

        }
      });

  }

})();

/**
 * Created by zura on 12/12/16.
 */
(function () {
  'use strict';


  // Initialize Firebase
  var firebaseConfig = {
    apiKey: "AIzaSyA1RFC-9f4Sdyb9SPJMU3YIw-r8znfEUhA",
    authDomain: "secretsanta-7b0cc.firebaseapp.com",
    databaseURL: "https://secretsanta-7b0cc.firebaseio.com",
    storageBucket: "secretsanta-7b0cc.appspot.com",
    messagingSenderId: "735602713413"
  };
  firebase.initializeApp(firebaseConfig);

  angular
    .module('secretSantaFirebase')
    .constant('FirebaseConfig', firebaseConfig)
    .config(config);

  /** @ngInject */
  function config($firebaseRefProvider) {
    $firebaseRefProvider.registerUrl({
      default: firebaseConfig.databaseURL
    });
  }

})();
/**
 * Created by guga on 12/12/16.
 */
(function () {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController($scope, $rootScope, UserService, Auth, $state, $stateParams) {
    var vm = this;

    // Data
    $rootScope.UserService = UserService;

    // Methods
    vm.goBack = goBack;
    vm.logout = logout;

    init();

    ///////////

    function init() {

      $rootScope.$on('$stateChangeSuccess',
        function(event, toState, toParams, fromState, fromParams) {
          $state.current = toState;
        }
      );
      $rootScope.$watch('backState',function (newVal, oldVal) {
        if(newVal){
          vm.back = true;
        }else{
          vm.back = false;
        }
      });
      var userStateChangeFn = $rootScope.$on('userStateChange', function($event, user){
        if (user){
          vm.user = user;
          if($state.current.name == 'auth.login'){
            if($stateParams.groupId){
              $state.go('app.join-game',{groupId: $stateParams.groupId})
            }else{
              $state.go(Auth.mainState);
            }
          }
        } else {
          vm.user = null;
          // $state.go(Auth.loginState);
        }
      });
      $scope.$on('$destroy', userStateChangeFn);
    }

    function goBack() {
      $state.go($rootScope.backState, $rootScope.backStateParams);
      $rootScope.backState = null;
    }

    function logout() {
      firebase.auth().signOut().then(function () {
        $state.go('auth.login');
      });
    }

  }
})();
/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('secretSantaFirebase')
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
  }

})();

angular.module("secretSantaFirebase").run(["$templateCache", function($templateCache) {$templateCache.put("app/joinGame/joinGame.html","<div class=\"mdl-layout mdl-js-layout mdl-layout--fixed-header\"><header class=mdl-layout__header><div class=right-menu><img src={{vm.user.photoURL}} alt={{vm.user.displayName}} height=40px> &nbsp; {{vm.user.displayName}} <button id=demo-menu-lower-right class=\"mdl-button mdl-js-button mdl-button--icon\"><i class=material-icons>more_vert</i></button><ul class=\"mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect\" for=demo-menu-lower-right><li class=mdl-menu__item ng-click=vm.logOut()>გამოსვლა</li><li class=mdl-menu__item>Another Action</li><li disabled class=mdl-menu__item>Disabled Action</li><li class=mdl-menu__item>Yet Another Action</li></ul></div></header><main class=mdl-layout__content><div class=page-content><div class=\"acme-card-wide mdl-card\" style=\"text-align: center\"><div class=mdl-card__title></div><div class=caption-text><h4>შექმენი ჯგუფი და გაუზიარე სხვებს ან დაკლიკე შენთვის გაზიარებულ ლინკზე</h4></div></div><div class=\"acme-card-wide mdl-card\" style=\"text-align: center\"><div><!-- Simple Textfield --><form action=# id=createGroup><div class=\"mdl-textfield mdl-js-textfield\"><input class=textfield__input id=groupName type=text ng-model=vm.groupName><label class=mdl-textfield__label for=groupName>Enter Group Name</label></div>{{vm.groupName}}<div><button type=button class=\"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect\" ng-click=vm.createGroup()>Create Group</button></div></form></div></div><div class=\"acme-card-wide mdl-card\" style=\"text-align: center\"><div class=mdl-data-table><h5 class=caption>ჩემი ჯგუფები</h5><table><thead><tr><th>Group Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td class=mdl-data-table__cell--non-numeric>{{group.name}}</td><td><button class=\"mdl-button mdl-js-button mdl-button--icon\" ng-click=vm.copyGroupLink(group)><i class=material-icons>link</i></button> <button class=\"mdl-button mdl-js-button mdl-button--icon\" ng-click=vm.openGroup(group)><i class=material-icons>remove_red_eye</i></button> <button class=\"mdl-button mdl-js-button mdl-button--icon\" ng-click=vm.removeGroup(group)><i class=material-icons>delete</i></button></td></tr></tbody></table></div></div></div></main><!--<footer class=\"mdl-mini-footer\">--><!--<div class=\"mdl-mini-footer__right-section\">--><!--<div class=\"mdl-logo\">--><!--Secret Santa Group 2016&copy All Right Reserved.--><!--</div>--><!--</div>--><!--</footer>--></div>");
$templateCache.put("app/group/group.html","<div class=page-content><div class=\"acme-card-wide mdl-card\" style=\"text-align: center\"><div><div layout=row layout-align=\"center center\" style=\"padding: 24px\"><strong>{{vm.group.name}}</strong></div><!-- Accent-colored raised button --> <button class=\"mdl-button mdl-js-button mdl-button--raised mdl-button--accent\" ng-click=vm.generateAssignments() ng-if=!vm.generated>გენერირება</button><table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp\"><thead><tr><th>Avatar</th><th>Display Name</th><th>Email</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td class=mdl-data-table__cell--non-numeric style=\"padding-bottom: 15px\"><img ng-src={{user.photoURL}} alt=\"\" style=\"height: 35px\"></td><td class=mdl-data-table__cell--non-numeric>{{user.displayName}}</td><td class=mdl-data-table__cell--non-numeric>{{user.email}}</td><td><button class=\"mdl-button mdl-js-button mdl-button--icon\" ng-click=vm.removeUser(user) ng-hide=\"user.$id == vm.user.uid\"><i class=material-icons>delete</i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/login/login.html","<div id=login-form><div class=\"mdl-layout mdl-js-layout mdl-layout--fixed-header\"><header class=mdl-layout__header></header><main class=mdl-layout__content><div class=page-content><div class=\"acme-card-wide mdl-card\" style=\"text-align: center\"><div class=mdl-card__title></div><div><h3>გილოცავთ დამდეგ შობა-ახალწელს!</h3><h4>მოდი ვითამაშოთ Secret Santa.</h4><p>ამისათვის საჭიროა დარეგისტრირდე, შექმნა ჯგუფი და გაუზიარო ლინკი მეგობრებს ან გადახვიდე უკვე შენთვის გაზიარებულ ლინკზე.</p></div><div class=alert ng-show=vm.errorMessage>{{vm.errorMessage}}</div><div><button class=\"mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect login-button\" ng-click=vm.loginWithGoogle()><img src=/assets/images/GooglePlus.png> Google+ - ით შესვლა</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button class=\"mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect login-button\" ng-click=vm.loginWithFacebook()><img src=/assets/images/fbicon.png> Facebook - ით შესვლა</button></div></div></div></main><!--<footer class=\"mdl-mini-footer\">--><!--<div class=\"mdl-mini-footer__right-section\">--><!--<div class=\"mdl-logo\">--><!--Secret Santa Group 2016&copy All Right Reserved.--><!--</div>--><!--</div>--><!--</footer>--></div></div>");
$templateCache.put("app/main/main.html","<div class=page-content><div class=\"acme-card-wide mdl-card\" style=\"text-align: center\"><div class=mdl-card__title></div><div class=caption-text><h4>შექმენი ჯგუფი და გაუზიარე სხვებს ან დაკლიკე შენთვის გაზიარებულ ლინკზე</h4></div></div><div class=\"acme-card-wide mdl-card\" layout-align=\"center center\"><div><!-- Simple Textfield --><form action=# id=createGroup name=createGroupForm><md-input-container><label>Enter Group Name</label><input type=text ng-model=vm.groupName required id=idGroupContainer></md-input-container><md-button style=margin-bottom:31px class=\"md-raised md-primary\" ng-click=vm.createGroup() type=submit ng-disabled=createGroupForm.$invalid>Create Group</md-button></form></div><div ng-if=vm.recentUrl style=\"text-align: center\"><span>Copy the following URL and share to your friends</span><div class=copy-selection layout=row layout-align=\"center center\"><div layout=row class=content><input type=text ng-model=vm.recentUrl id=idCopyTextMain readonly><md-button ng-click=vm.copy($event) class=md-icon-button><i class=material-icons>content_copy</i><md-tooltip>Copy</md-tooltip></md-button></div></div></div></div><div class=\"acme-card-wide mdl-card\" style=\"text-align: center\"><div class=mdl-data-table><h5 class=caption>ჩემი ჯგუფები</h5><table><thead><tr><th>Owner</th><th>Group Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td class=mdl-data-table__cell--non-numeric><input type=checkbox ng-value=\"group.creatorId == vm.user.uid\" readonly></td><td class=mdl-data-table__cell--non-numeric>{{group.name}}</td><td><md-button class=md-icon-button ng-click=vm.copyGroupLink(group)><i class=material-icons>link</i></md-button><md-button class=md-icon-button ng-click=vm.openGroup(group)><i class=material-icons>remove_red_eye</i></md-button><md-button class=md-icon-button ng-if=\"group.creatorId == vm.user.uid\" ng-click=vm.removeGroup(group)><i class=material-icons>delete</i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/layouts/content.html","<div id=login-form><div class=\"mdl-layout mdl-js-layout mdl-layout--fixed-header\"><main class=mdl-layout__content ui-view=content></main><!--<footer class=\"mdl-mini-footer\">--><!--<div class=\"mdl-mini-footer__right-section\">--><!--<div class=\"mdl-logo\">--><!--Secret Santa Group 2016&copy All Right Reserved.--><!--</div>--><!--</div>--><!--</footer>--></div></div>");
$templateCache.put("app/layouts/main.html","<div class=\"mdl-layout mdl-js-layout mdl-layout--fixed-header\"><header class=mdl-layout__header><div class=left-menu><md-button class=md-icon-button ng-click=vm.goBack() ng-if=vm.back><i class=material-icons>keyboard_arrow_left</i></md-button></div><img src={{vm.user.photoURL}} alt={{vm.user.displayName}} height=40px> <strong>{{vm.user.displayName}}</strong><md-menu class=right-menu><md-button ng-click=$mdOpenMenu($event) class=md-icon-button><i class=material-icons>more_vert</i></md-button><md-menu-content><md-menu-item><md-button ng-click=vm.logout()>Log Out</md-button></md-menu-item></md-menu-content></md-menu></header><div ui-view=content></div><!--<footer class=\"mdl-mini-footer\">--><!--<div class=\"mdl-mini-footer__right-section\">--><!--<div class=\"mdl-logo\">--><!--Secret Santa Group 2016&copy All Right Reserved.--><!--</div>--><!--</div>--><!--</footer>--></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=mdl-layout__header-row><!-- Title --> <span class=\"mdl-layout-title mdl-badge\">Secret Santa</span><!-- Add spacer, to align navigation to the right --><nav class=\"mdl-navigation mdl-layout--large-screen-only\"><!--<a class=\"mdl-navigation__link\" href=\"#\">Home</a>--><!--<a class=\"mdl-navigation__link\" href=\"#\">About</a>--><!--<a class=\"mdl-navigation__link\" href=\"#\">Contact</a>--></nav><!-- Add spacer, to align navigation to the right --><div class=mdl-layout-spacer></div><!-- Navigation. We hide it in small screens. --> <span class=mdl-navigation__link>Application was created {{ vm.relativeDate }}.</span></div>");
$templateCache.put("app/main/dialogs/copy-dialog/copy-dialog.html","<div class=copy-selection><strong>Copy Url</strong><div layout=row class=content><input type=text ng-model=vm.link id=idCopyText readonly><md-button ng-click=vm.copy($event) class=md-icon-button><i class=material-icons>content_copy</i><md-tooltip>Copy</md-tooltip></md-button></div><div layout=row layout-align=\"end center\"><md-button ng-click=vm.close()>Close</md-button></div></div>");}]);